import { createSelector } from 'reselect';

export const selectStateHeader = () => state => state.header;

export const selectHeader = () =>
  createSelector(
    selectStateHeader(),
    stateHeader => stateHeader.menuBurguer
  );
